import { render, staticRenderFns } from "./WeCircularNavbar.vue?vue&type=template&id=f971b622&scoped=true"
import script from "./WeCircularNavbar.vue?vue&type=script&lang=js"
export * from "./WeCircularNavbar.vue?vue&type=script&lang=js"
import style0 from "./WeCircularNavbar.vue?vue&type=style&index=0&id=f971b622&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f971b622",
  null
  
)

export default component.exports